import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeEnComponent } from './home-en/home-en.component';
import { HomeArComponent } from './home-ar/home-ar.component';
import { EstateEnComponent } from './estate-en/estate-en.component';
import { EstateArComponent } from './estate-ar/estate-ar.component';
import { ProjectsComponent } from './projects/projects.component';
import { AllegriaArComponent } from './allegria-ar/allegria-ar.component';
import { AllegriaComponent } from './allegria/allegria.component';
import { VyeEnComponent } from './vye-en/vye-en.component';
import { VyeArComponent } from './vye-ar/vye-ar.component';
import { EastvaleEnComponent } from './eastvale-en/eastvale-en.component';
import { EastvaleArComponent } from './eastvale-ar/eastvale-ar.component';

const routes: Routes = [
  {
    path: '',
    component: HomeEnComponent,
    pathMatch: 'full',
  },
  {
    path: 'ar',
    component: HomeArComponent,
  },
  {
    path: 'estate-en',
    component: EstateEnComponent,
  },
  {
    path: 'estate-ar',
    component: EstateArComponent,
  },
  {
    path: 'projects',
    component: ProjectsComponent,
    loadChildren: () =>
      import('./projects/project.module').then((m) => m.ProjectModule),
  },
  {
    path: 'allegria-en',
    component: AllegriaComponent,
  },
  {
    path: 'allegria-ar',
    component: AllegriaArComponent,
  },
  {
    path: 'vye-en',
    component: VyeEnComponent,
  },
  {
    path: 'vye-ar',
    component: VyeArComponent,
  },
  {
    path: 'eastvale-en',
    component: EastvaleEnComponent,
  },
  {
    path: 'eastvale-ar',
    component: EastvaleArComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
